import { render, staticRenderFns } from "./ChargePolicyCom.vue?vue&type=template&id=3c8c2ba3&"
import script from "./ChargePolicyCom.vue?vue&type=script&lang=ts&"
export * from "./ChargePolicyCom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports